// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DatabrowserSectionOne {
  padding: 120px 180px;
  background: #f9ebd3;
  height: auto;
  width: 100%;
}
.DatabrowserSectionOne .DatabrowserSectionOne-head {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 40px;
}
.DatabrowserSectionOne .DatabrowserSectionOne-head .DatabrowserSectionOne-header {
  font-family: Roboto;
  font-size: 48px;
  margin-bottom: 40px;
  text-align: center;
}
.DatabrowserSectionOne .DatabrowserSectionOne-head .DatabrowserSectionOne-sub {
  font-family: Roboto;
  font-size: 18px;
  text-align: center;
}

.DatabrowserSectionOne-Menu .ui.secondary.pointing.menu {
  height: 60px;
  justify-content: center;
  align-items: center;
  border-bottom: 3px solid #f7f7f7 !important;
  text-align: center;
}
.DatabrowserSectionOne-Menu .ui.secondary.pointing.menu .item {
  width: auto;
  height: 60px;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #1c2640 !important;
  opacity: 1 !important;
  margin: 0 90px;
}
.DatabrowserSectionOne-Menu .ui.secondary.pointing.menu .item .ui.header {
  font-size: 20px;
  font-weight: 500;
  font-family: "Roboto", Roboto !important;
  color: #1c2640;
  line-height: 1.86;
  height: 55px;
  padding: inherit;
}
.DatabrowserSectionOne-Menu .ui.secondary.pointing.menu .item:hover {
  cursor: pointer;
}
.DatabrowserSectionOne-Menu .ui.secondary.pointing.menu .item:hover .ui.header {
  color: #ec7c45;
  border-bottom: 4px solid #ec7c45;
  transition: 0.4s;
}
.DatabrowserSectionOne-Menu .ui.secondary.pointing.menu > .item.active, .DatabrowserSectionOne-Menu .ui.secondary.pointing.menu > .menu > .item.active {
  border-color: transparent;
}
.DatabrowserSectionOne-Menu .ui.secondary.pointing.menu > .item.active .ui.header {
  color: #ec7c45;
  border-bottom: 4px solid #ec7c45;
}

.content-wrapper {
  padding: 100px 180px;
  background: #e2e6fb;
  opacity: 1;
  animation-name: fadeInOpacity;
  animation-iteration-count: 1;
  animation-timing-function: ease-in;
  animation-duration: 1s;
}
.content-wrapper .header {
  font-family: Roboto;
  text-align: center;
  font-size: 43px;
  margin-bottom: 80px;
  font-weight: 500;
}
.content-wrapper .header .sub-header {
  font-size: 18px;
  margin-top: 20px;
  color: #52667C;
}
.content-wrapper .section-custom {
  display: flex;
  margin-bottom: 60px;
  gap: 4%;
}
.content-wrapper .section-custom .content-wrapper-left {
  width: 50%;
}
.content-wrapper .section-custom .content-wrapper-left .header1 {
  text-transform: uppercase;
  color: #52667C;
  font-size: 20px;
  font-weight: 500;
}
.content-wrapper .section-custom .content-wrapper-left .header2 {
  font-family: "Roboto", Roboto !important;
  color: #1C2640;
  font-size: 43px;
  font-weight: 400;
  line-height: 1.3;
  margin-top: 5px;
  margin-bottom: 30px;
}
.content-wrapper .section-custom .content-wrapper-left .header3 {
  font-family: "Roboto", Roboto !important;
  color: #1C2640;
  font-size: 30px;
  font-weight: 500;
  line-height: 1.3;
  margin-top: 5px;
  margin-bottom: 30px;
}
.content-wrapper .section-custom .content-wrapper-left .txt-content {
  color: #52667C;
  font-size: 18px;
}
.content-wrapper .section-custom .content-wrapper-left .txt-content ul {
  padding-left: 20px;
  margin-top: -15px;
  line-height: 1.8;
}
.content-wrapper .section-custom .content-wrapper-left .txt-content li {
  color: #ec7c45;
}
.content-wrapper .section-custom .content-wrapper-left .txt-content span {
  color: #52667C;
}
.content-wrapper .section-custom .content-wrapper-left .txt-content p {
  line-height: 1.8;
}
.content-wrapper .section-custom .content-wrapper-right {
  width: 50%;
}
.content-wrapper .section-custom .content-wrapper-right img {
  margin-left: -30px;
}
.content-wrapper .DatabrowserStack {
  justify-content: center;
  align-items: center;
}
.content-wrapper .DatabrowserStack .img-DatabrowserStack {
  padding-left: 50px;
}
.content-wrapper .Audit {
  justify-content: center;
  align-items: center;
  margin-bottom: -40px !important;
}
.content-wrapper .section-custom-2 {
  margin-bottom: 60px;
  display: flex;
  gap: 4%;
}
.content-wrapper .section-custom-2 .content-wrapper-right {
  width: 45%;
  margin-left: 50px;
}
.content-wrapper .section-custom-2 .content-wrapper-right .header1 {
  text-transform: uppercase;
  color: #52667C;
  font-size: 20px;
  font-weight: 500;
}
.content-wrapper .section-custom-2 .content-wrapper-right .header2 {
  color: #1C2640;
  font-size: 43px;
  font-weight: 400;
  line-height: 1.3;
  margin-top: 5px;
  margin-bottom: 30px;
}
.content-wrapper .section-custom-2 .content-wrapper-right .header3 {
  font-family: "Roboto", Roboto !important;
  color: #1C2640;
  font-size: 30px;
  font-weight: 500;
  line-height: 1.3;
  margin-top: 5px;
  margin-bottom: 30px;
}
.content-wrapper .section-custom-2 .content-wrapper-right .txt-content {
  color: #52667C;
  font-size: 18px;
}
.content-wrapper .section-custom-2 .content-wrapper-right .txt-content ul {
  padding-left: 20px;
  margin-top: -10px;
  line-height: 1.8;
}
.content-wrapper .section-custom-2 .content-wrapper-right .txt-content li {
  color: #ec7c45;
}
.content-wrapper .section-custom-2 .content-wrapper-right .txt-content span {
  color: #52667C;
}
.content-wrapper .section-custom-2 .content-wrapper-left {
  width: 55%;
  margin-top: -20px;
  margin-left: -45px;
}

.Databrowser-content-wrapper .section-content .box-list {
  display: flex;
  gap: 8%;
  justify-content: center;
  margin-bottom: 30px;
}
.Databrowser-content-wrapper .section-content .box-list .box {
  width: 50%;
  background: #fff;
  padding: 40px;
  text-align: center;
  border-radius: 12px;
  box-shadow: 5px 5px 5px rgba(51, 51, 51, 0.25);
}
.Databrowser-content-wrapper .section-content .box-list .box .box-header {
  font-weight: 700;
  font-family: "Roboto";
  line-height: 25px;
  font-size: 18px;
  margin-bottom: 20px;
  color: #52667C;
}
.Databrowser-content-wrapper .section-content .box-list .box .box-content {
  font-weight: 400;
  font-family: "Roboto";
  line-height: 25px;
  font-size: 16px;
  color: #52667C;
}
.Databrowser-content-wrapper .section-content .multi-box .box {
  width: 33.3% !important;
  min-height: 230px;
}
.Databrowser-content-wrapper .header-small {
  text-align: center;
  margin-top: 100px;
  font-weight: 400;
  font-size: 24px;
}
.Databrowser-content-wrapper .content {
  margin-top: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.Databrowser-content-wrapper .content .img-approach {
  width: 98%;
}

@keyframes fadeInOpacity {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Databrowser/SectionOne/SectionOne.scss"],"names":[],"mappings":"AAAA;EACC,oBAAA;EACA,mBAAA;EACG,YAAA;EACA,WAAA;AACJ;AAAI;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,iBAAA;AAEL;AADK;EACC,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;AAGN;AADK;EACC,mBAAA;EACA,eAAA;EACA,kBAAA;AAGN;;AAGC;EACC,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,2CAAA;EACG,kBAAA;AAAL;AAGC;EACC,WAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;EACA,qBAAA;EACA,cAAA;AADF;AAEE;EACC,eAAA;EACA,gBAAA;EACA,wCAAA;EACA,cAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;AAAH;AAIC;EACC,eAAA;AAFF;AAGE;EACC,cAAA;EACA,gCAAA;EACA,gBAAA;AADH;AAKC;EACC,yBAAA;AAHF;AAOE;EACC,cAAA;EACA,gCAAA;AALH;;AAUA;EACC,oBAAA;EACG,mBAAA;EACA,UAAA;EACH,6BAAA;EACA,4BAAA;EACA,kCAAA;EACA,sBAAA;AAPD;AAQC;EACC,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;AANF;AAQE;EACC,eAAA;EACA,gBAAA;EACA,cAAA;AANH;AAUC;EACC,aAAA;EACA,mBAAA;EACA,OAAA;AARF;AASE;EACC,UAAA;AAPH;AAQG;EACC,yBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AANJ;AAQG;EACC,wCAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;AANJ;AASG;EACC,wCAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;AAPJ;AASG;EACC,cAAA;EACA,eAAA;AAPJ;AAQI;EACC,kBAAA;EACA,iBAAA;EACA,gBAAA;AANL;AAQI;EAAK,cAAA;AALT;AAMI;EAAO,cAAA;AAHX;AAII;EAAG,gBAAA;AADP;AAIE;EACC,UAAA;AAFH;AAIG;EACC,kBAAA;AAFJ;AAOC;EACC,uBAAA;EACA,mBAAA;AALF;AAME;EACC,kBAAA;AAJH;AAQC;EACC,uBAAA;EACA,mBAAA;EACA,+BAAA;AANF;AASC;EACC,mBAAA;EACA,aAAA;EACA,OAAA;AAPF;AAQE;EACC,UAAA;EACA,iBAAA;AANH;AAOG;EACC,yBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AALJ;AAOG;EACC,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;AALJ;AAQG;EACC,wCAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;AANJ;AASG;EACC,cAAA;EACA,eAAA;AAPJ;AAQI;EACC,kBAAA;EACA,iBAAA;EACA,gBAAA;AANL;AAQI;EAAK,cAAA;AALT;AAMI;EAAO,cAAA;AAHX;AAME;EACC,UAAA;EACA,iBAAA;EACA,kBAAA;AAJH;;AAWE;EACC,aAAA;EACA,OAAA;EAEG,uBAAA;EACA,mBAAA;AATN;AAUM;EAEC,UAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,8CAAA;AATP;AAUO;EACC,gBAAA;EACA,qBAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;AARR;AAUI;EACC,gBAAA;EACG,qBAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;AARR;AAcG;EACC,uBAAA;EACA,iBAAA;AAZJ;AAiBC;EACI,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;AAfL;AAiBC;EACI,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAfL;AAgBK;EACC,UAAA;AAdN;;AAmBA;EACC;IACC,UAAA;EAhBA;EAkBD;IACC,UAAA;EAhBA;AACF","sourcesContent":[".DatabrowserSectionOne {\n\tpadding: 120px 180px;\n\tbackground: #f9ebd3;\n    height: auto;\n    width: 100%;\n    .DatabrowserSectionOne-head {\n    \tdisplay: flex;\n\t    flex-direction: column;\n\t    align-items: center;\n\t    padding-top: 40px;\n\t    .DatabrowserSectionOne-header {\n\t    \tfont-family: Roboto;\n\t    \tfont-size: 48px;\n\t    \tmargin-bottom: 40px;\n\t    \ttext-align: center;\n\t    }\n\t    .DatabrowserSectionOne-sub {\n\t    \tfont-family: Roboto;\n\t    \tfont-size: 18px;\n\t    \ttext-align: center;\n\t    }\n    }\n}\n\n.DatabrowserSectionOne-Menu {\n\t.ui.secondary.pointing.menu {\n\t\theight: 60px;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tborder-bottom: 3px solid #f7f7f7 !important;\n\t    text-align: center;\n\t}\n\n\t.ui.secondary.pointing.menu .item {\n\t\twidth: auto;\n\t\theight: 60px;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\ttext-align: center;\n\t\tcolor: #1c2640 !important;\n\t\topacity: 1 !important;\n\t\tmargin: 0 90px;\n\t\t.ui.header {\n\t\t\tfont-size: 20px;\n\t\t\tfont-weight: 500;\n\t\t\tfont-family: 'Roboto', Roboto !important;\n\t\t\tcolor: #1c2640;\n\t\t\tline-height: 1.86;\n\t\t\theight: 55px;\n\t\t\tpadding: inherit;\n\t\t}\n\t}\n\n\t.ui.secondary.pointing.menu .item:hover {\n\t\tcursor: pointer;\n\t\t.ui.header {\n\t\t\tcolor: #ec7c45;\n\t\t\tborder-bottom: 4px solid #ec7c45;\n\t\t\ttransition: 0.4s;\n\t\t}\n\t}\n\n\t.ui.secondary.pointing.menu>.item.active, .ui.secondary.pointing.menu>.menu>.item.active {\n\t\tborder-color: transparent;\n\t}\n\n\t.ui.secondary.pointing.menu >.item.active{\n\t\t.ui.header {\n\t\t\tcolor: #ec7c45;\n\t\t\tborder-bottom: 4px solid #ec7c45;\n\t\t}\n\t}\n}\n\n.content-wrapper {\n\tpadding: 100px 180px;\n    background: #e2e6fb;\n    opacity: 1;\n\tanimation-name: fadeInOpacity;\n\tanimation-iteration-count: 1;\n\tanimation-timing-function: ease-in;\n\tanimation-duration: 1s;\n\t.header {\n\t\tfont-family: Roboto;\n\t\ttext-align: center;\n\t\tfont-size: 43px;\n\t\tmargin-bottom: 80px;\n\t\tfont-weight: 500;\n\n\t\t.sub-header{\n\t\t\tfont-size:18px; \n\t\t\tmargin-top: 20px;\n\t\t\tcolor: #52667C;\n\t\t}\n\t}\n\n\t.section-custom {\n\t\tdisplay: flex;\n\t\tmargin-bottom: 60px;\n\t\tgap: 4%;\n\t\t.content-wrapper-left {\n\t\t\twidth: 50%;\n\t\t\t.header1 {\n\t\t\t\ttext-transform: uppercase;\n\t\t\t\tcolor: #52667C;\n\t\t\t\tfont-size: 20px;\n\t\t\t\tfont-weight: 500;\n\t\t\t}\n\t\t\t.header2 {\n\t\t\t\tfont-family: 'Roboto', Roboto !important;\n\t\t\t\tcolor: #1C2640;\n\t\t\t\tfont-size: 43px;\n\t\t\t\tfont-weight: 400;\n\t\t\t\tline-height: 1.3;\n\t\t\t\tmargin-top: 5px;\n\t\t\t\tmargin-bottom: 30px;\n\t\t\t}\n\n\t\t\t.header3 {\n\t\t\t\tfont-family: 'Roboto', Roboto !important;\n\t\t\t\tcolor: #1C2640;\n\t\t\t\tfont-size: 30px;\n\t\t\t\tfont-weight: 500;\n\t\t\t\tline-height: 1.3;\n\t\t\t\tmargin-top: 5px;\n\t\t\t\tmargin-bottom: 30px;\n\t\t\t}\n\t\t\t.txt-content {\n\t\t\t\tcolor: #52667C;\n\t\t\t\tfont-size: 18px;\n\t\t\t\tul {\n\t\t\t\t\tpadding-left: 20px;\n\t\t\t\t\tmargin-top: -15px;\n\t\t\t\t\tline-height: 1.8;\n\t\t\t\t}\n\t\t\t\tli { color: #ec7c45; }\n\t\t\t\tspan { color: #52667C; }\n\t\t\t\tp {line-height: 1.8}\n\t\t\t}\n\t\t}\n\t\t.content-wrapper-right {\n\t\t\twidth: 50%;\n\t\t\t// margin-top: -20px;\n\t\t\timg {\n\t\t\t\tmargin-left: -30px;\n\t\t\t}\n\t\t}\n\t}\n\n\t.DatabrowserStack{\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\t.img-DatabrowserStack{\n\t\t\tpadding-left: 50px;\n\t\t}\n\t}\n\n\t.Audit{\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tmargin-bottom: -40px !important;\n\t}\n\n\t.section-custom-2 {\n\t\tmargin-bottom: 60px;\n\t\tdisplay: flex;\n\t\tgap: 4%;\n\t\t.content-wrapper-right {\n\t\t\twidth: 45%;\n\t\t\tmargin-left: 50px;\n\t\t\t.header1 {\n\t\t\t\ttext-transform: uppercase;\n\t\t\t\tcolor: #52667C;\n\t\t\t\tfont-size: 20px;\n\t\t\t\tfont-weight: 500;\n\t\t\t}\n\t\t\t.header2 {\n\t\t\t\tcolor: #1C2640;\n\t\t\t\tfont-size: 43px;\n\t\t\t\tfont-weight: 400;\n\t\t\t\tline-height: 1.3;\n\t\t\t\tmargin-top: 5px;\n\t\t\t\tmargin-bottom: 30px;\n\t\t\t}\n\n\t\t\t.header3 {\n\t\t\t\tfont-family: 'Roboto', Roboto !important;\n\t\t\t\tcolor: #1C2640;\n\t\t\t\tfont-size: 30px;\n\t\t\t\tfont-weight: 500;\n\t\t\t\tline-height: 1.3;\n\t\t\t\tmargin-top: 5px;\n\t\t\t\tmargin-bottom: 30px;\n\t\t\t}\n\n\t\t\t.txt-content {\n\t\t\t\tcolor: #52667C;\n\t\t\t\tfont-size: 18px;\n\t\t\t\tul {\n\t\t\t\t\tpadding-left: 20px;\n\t\t\t\t\tmargin-top: -10px;\n\t\t\t\t\tline-height: 1.8;\n\t\t\t\t}\n\t\t\t\tli { color: #ec7c45; }\n\t\t\t\tspan { color: #52667C; }\n\t\t\t}\n\t\t}\n\t\t.content-wrapper-left {\n\t\t\twidth: 55%;\n\t\t\tmargin-top: -20px;\n\t\t\tmargin-left: -45px;\n\t\t}\n\t}\n}\n\n.Databrowser-content-wrapper{\n\t.section-content{\n\t\t.box-list{\n\t\t\tdisplay: flex;\n\t\t\tgap: 8%;\n\t\t\t// align-items: center;\n    \t\tjustify-content: center;\n    \t\tmargin-bottom: 30px;\n    \t\t.box{\n    \t\t\t// min-height: 350px;\n    \t\t\twidth: 50%;\n    \t\t\tbackground: #fff;\n\t\t\t    padding: 40px;\n\t\t\t    text-align: center;\n\t\t\t    border-radius: 12px;\n\t\t\t    box-shadow: 5px 5px 5px rgba(51, 51, 51, 0.25);\n\t\t\t    .box-header {\n\t\t\t\t    font-weight: 700;\n\t\t\t\t    font-family: 'Roboto';\n\t\t\t\t    line-height: 25px;\n\t\t\t\t    font-size: 18px;\n\t\t\t\t    margin-bottom: 20px;\n\t\t\t\t    color: #52667C;\n\t\t\t\t}\n\t\t\t\t.box-content{\n\t\t\t\t\tfont-weight: 400;\n\t\t\t\t    font-family: 'Roboto';\n\t\t\t\t    line-height: 25px;\n\t\t\t\t    font-size: 16px;\n\t\t\t\t    color: #52667C;\n\t\t\t\t}\n    \t\t}\n\t\t}\n\n\t\t.multi-box{\n\t\t\t.box{\n\t\t\t\twidth: 33.3% !important;\n\t\t\t\tmin-height: 230px;\n\t\t\t}\n\t\t\t\n\t\t}\n\t}\n\t.header-small {\n\t    text-align: center;\n\t    margin-top: 100px;\n\t    font-weight: 400;\n\t    font-size: 24px;\n\t}\n\t.content {\n\t    margin-top: 100px;\n\t    display: flex;\n\t    justify-content: center;\n\t    align-items: center;\n\t    .img-approach {\n\t\t    width: 98%;\n\t\t}\n\t}\n}\n\n@keyframes fadeInOpacity {\n\t0% {\n\t\topacity: 0;\n\t}\n\t100% {\n\t\topacity: 1;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
